function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

import _extends from '@babel/runtime/helpers/extends';
import { __rest } from 'tslib';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

var HEADINGS = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6'
};
var Heading = /*#__PURE__*/forwardRef(function (_a, ref) {
  var block = _a.block,
      children = _a.children,
      className = _a.className,
      _b = _a.focusable,
      focusable = _b === void 0 ? true : _b,
      level = _a.level,
      props = __rest(_a, ["block", "children", "className", "focusable", "level"]);

  var HeadingElement = HEADINGS[level];

  if (!HeadingElement) {
    return null;
  }

  var tabIndex = focusable ? -1 : undefined;
  var headingClass = classNames(className, {
    'a11y-heading': !block
  });
  return /*#__PURE__*/React.createElement(HeadingElement, _extends({
    ref: ref,
    className: headingClass || undefined,
    tabIndex: tabIndex
  }, props), children);
});
Heading.displayName = 'Heading';

export { Heading };
